import { render, staticRenderFns } from "./dialogCustomizeThemes.vue?vue&type=template&id=8a4283fc&"
import script from "./dialogCustomizeThemes.vue?vue&type=script&lang=js&"
export * from "./dialogCustomizeThemes.vue?vue&type=script&lang=js&"
import style0 from "./dialogCustomizeThemes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VBtn,VCard,VColorPicker,VFileInput,VMenu,VRow,VSelect})
